import { SimilarMention } from "@/types/Mention";
import Typography from "@components/Typography";

import styles from "./SimilarNewsArticle.module.css";

const SimilarNewsArticle: React.FunctionComponent<SimilarMention> = ({
  channel_title,
  mention_link,
  episode_title,
}) => {
  return (
    <a
      href={mention_link}
      className={styles.root}
      target="_blank"
      rel="noreferrer"
    >
      <Typography margin="none" className={styles.text}>
        <strong>{channel_title}</strong>: {episode_title}
      </Typography>
    </a>
  );
};

export default SimilarNewsArticle;
